module.exports = __webpack_public_path__ + "images/backgrounds/snow/medium.147471be1b6fa8858c40.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/snow/medium.jpg
// module id = 34vz
// module chunks = 2